<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-card" @click.stop>
      <div class="flexbox-row flex-start">
        <span class="icon-wrapper" :class="{ 'primary': isPrimary }">
          <icon :name="iconName" :variant="iconVariant"></icon>
        </span>
        <button
          class="button-reset"
          data-test="close-modal"
          @click="closeModal"
        >
          <icon name="close-x" variant="98A2B3" />
        </button>
      </div>
      <div class="text-lg font-semibold text-primary header">
        <slot name="header"></slot>
      </div>
      <slot></slot>
      <div class="button-row">
        <button
          v-if="!hideCancel"
          class="button-reset button-basic font-semibold"
          @click="$emit('close')"
        >
          {{ cancelText }}
        </button>
        <button
          class="button-reset button-basic text-md font-semibold"
          data-test="confirm-button"
          :class="{
            'button-error': !isPrimary,
            'full-width': hideCancel,
            'button-primary': isPrimary,
          }"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'BaseModal',
  components: {
    Icon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: 'warning-inverse',
    },
    iconVariant: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'confirm'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">

.icon-wrapper {
  width: rem-calc(48);
  height: rem-calc(48);
  display: grid;
  place-items: center;
  background-color: var(--bg-error-secondary);
  border-radius: 50%;

  &.primary {
    background-color: var(--faded-primary-bg);
  }
}

.button-row {
  margin-top: rem-calc(24);
  display: grid;
  gap: rem-calc(12);
}

.header {
  margin-top: rem-calc(16);
  margin-bottom: rem-calc(4);
}

.modal-overlay {
  position: fixed;
  display: grid;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 950;
}

.modal-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: rgb(250, 250, 250);
  color: rgba(71, 84, 103, 1);
  border-radius: 12px;
  padding: rem-calc(24);
  min-width: rem-calc(340);
  max-width: clamp(0px, 90vw, 400px);
  min-height: rem-calc(16);
  overflow-x: hidden;
  overflow-y: auto;
  font-size: var(--Fontsizetext-md);
  line-height: var(--Lineheighttext-md);
  margin: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@include breakpoint(tablet) {
  .button-row {
    grid-template-columns: repeat(2, 1fr);

    .full-width {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
}

@include breakpoint(desktop) {
  .button-row {
    grid-template-columns: repeat(2, 1fr);

    .full-width {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
}
</style>
